<template>
  <CsApp />
</template>

<script lang="ts" setup>
import { CsApp } from 'lifesci-ui'
import { useI18n } from 'vue-i18n'
import { ref, provide, watch } from 'vue'

const displayTerm = ref('')
const { locale } = useI18n()

watch(
  () => locale.value,
  () => {
    switch(locale.value) {
      case 'en':
        displayTerm.value = 'en'
        break
      case 'zh-CN':
        displayTerm.value = 'zh'
        break
    }
  },
  { immediate: true }
)

provide('displayTerm', displayTerm)
</script>

<style lang="scss" scoped></style>
